import React from 'react'

const PersonalInformation = ({ appraiserInfo }) =>
  <div className='appraiser-personal-information'>
    <h3>Personal Information</h3>
    {appraiserInfo.fetching && <div>Loading...</div>}
    {appraiserInfo && !appraiserInfo.error && !appraiserInfo.fetching &&
      <table>
        <tbody>
          <tr>
            <th scope='row'>Sex</th>
            <td>{appraiserInfo.gender}</td>
          </tr>
          <tr>
            <th scope='row'>Race</th>
            <td>{appraiserInfo.race}</td>
          </tr>
        </tbody>
      </table>}
    {appraiserInfo.error && <div className='appraiserError'>Error: Unable to load personal information.</div>}
  </div>

export default PersonalInformation
